import React from 'react';
import styled from 'styled-components';
import {
  flexBoxCenter,
  justifyContentSpaceBetween,
  layerA,
  layerDegHPB,
  layerDegHPD,
} from '../../styles/commonStyles';
import HpMasterControl from './masterControl';
import OverSightHP from './overSightHP';
import StationMap from './viewStationInfo';

const HpMasterControlAndOverSight = ({ dataAccessKey }) => {
  return (
    <Wrapper>
      <InnerWrapper>
        <ControlWrapper>
          <ControlInnerWrapper>
            <HpMasterControl />
            <StationMap />
          </ControlInnerWrapper>
        </ControlWrapper>
        <OverSightWrapper>
          <OverSightInnerWrapper>
            <OverSightHP dataAccessKey={dataAccessKey} />
          </OverSightInnerWrapper>
        </OverSightWrapper>
      </InnerWrapper>
    </Wrapper>
  );
};

export default HpMasterControlAndOverSight;

const Wrapper = styled.section`
  width: 1202px;
  min-height: 946px;
  height: auto;
  padding: 2px;
  ${layerA}
  border-radius: 53px 53px 31px 31px;
  ${flexBoxCenter}
`;

const InnerWrapper = styled.div`
  width: 1196px;
  min-height: 928px;
  height: auto;

  padding-top: 5px;
  padding-bottom: 2px;

  ${layerDegHPB}

  border-radius: 50px 50px 30px 30px;
  ${justifyContentSpaceBetween}
  flex-direction: column;
  gap: 12px;
`;

const ControlWrapper = styled.section`
  width: 1184px;
  height: 722px;

  ${layerA}
  border-radius: 44px;

  ${flexBoxCenter}
`;

const ControlInnerWrapper = styled.div`
  width: 1178px;
  height: 716px;

  ${layerDegHPD}

  border-radius: 42px;

  ${flexBoxCenter}
  gap:4px;
`;

const OverSightWrapper = styled.section`
  width: 1188px;
  min-height: 180px;
  height: auto;

  padding-top: 3px;
  padding-bottom: 3px;

  border-radius: 27px;
  ${layerA}
  box-shadow: 0.5px 0.5px 1px 0px rgba(0, 0, 0, 0.62) inset;

  ${flexBoxCenter}
`;

const OverSightInnerWrapper = styled.div`
  width: 1182px;
  min-height: 174px;
  height: auto;

  border-radius: 25px;
  ${layerDegHPD}
  box-shadow: 0.5px 0.5px 1px 0px rgba(255, 255, 255, 0.2) inset;

  ${flexBoxCenter}
`;
